import React, { createContext, useContext, useState } from 'react';
import { Delivery, DeliveryGroup, DeliveryComment, CommentCode, Order, Route, Driver, User } from 'typings/models';

interface TravelContextProps {
    order: Order | null;
    allRoutes: Route[];
    route: Route | null;
    driver: Driver | null;
    deliveryGroup: DeliveryGroup | null;
    user: User | null;

    setOrder: (order: Order | null) => void;
    setAllRoutes: (routes: Route[]) => void;
    setRoute: (route: Route | null) => void;
    setDriver: (driver: Driver) => void;
    setDeliveryGroup: (deliveryGroup: DeliveryGroup) => void;
    updateDelivery: (delivery: Delivery) => void;
    commentCodes: CommentCode[];
    setCommentCodes: (commentCodes: CommentCode[]) => void;
    setUser: (user: User | null) => void;
}

const TravelContext = createContext<TravelContextProps | undefined>(undefined);

export const useTravelContext = () => {
    const context = useContext(TravelContext);
    if (!context) {
        throw new Error('useTravelContext must be used within a TravelProvider');
    }
    return context;
};

export const TravelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [order, setOrder] = useState<Order | null>(null);
    const [allRoutes, setAllRoutes] = useState<Route[]>([]);
    const [route, setRoute] = useState<Route | null>(null);
    const [driver, setDriver] = useState<Driver | null>(null);
    const [deliveryGroup, setDeliveryGroup] = useState<DeliveryGroup | null>(null);
    const [commentCodes, setCommentCodes] = useState<CommentCode[]>([]);
    const [user, setUser] = useState<User | null>(null);

    const updateDelivery = (delivery: Delivery) => {
        if (!deliveryGroup) return;
        setDeliveryGroup(prevDeliveryGroup => ({
            ...prevDeliveryGroup!,
            deliveries: prevDeliveryGroup!.deliveries.map(d => 
                d.id === delivery.id ? delivery : d
            )
        }));
    };


    return <TravelContext.Provider
        value={{ order, route, driver, deliveryGroup, allRoutes, user,
         setOrder, setRoute, setDriver, setDeliveryGroup, updateDelivery, commentCodes, setCommentCodes, setAllRoutes, setUser }}>
        {children}
    </TravelContext.Provider>;
};
